const state = {
    toasts: [],
    navbar_collapsed: false
};

const mutations = {
    addToast(state, toast) {
        state.toasts.push(toast);
    },
    removeToast(state, {
        index
    }) {
        state.toasts.splice(index, 1);
    },
    setNavbarCollapsed(state, value) {
        state.navbar_collapsed = value;
    }
};

const actions = {

};

module.exports = {
    namespaced: true,
    state,
    mutations,
    actions
}